/* eslint-disable */
import Vue from 'vue';
import api from './../api';
import store from './../../store';
import { Indicator, Toast } from 'mint-ui';

// When the request succeeds
const success = (token) => {
  if (token !== null) {
    store.dispatch('login', token);
  }
  /* Goes to last path if exist if not goes home */
  if (localStorage.getItem('to') === null) {
    Vue.router.replace({
      name: 'home',
    });
  } else {
    // Return to the next route
    Vue.router.replace({
      path: localStorage.getItem('to'),
    });
    // Removeing the [to] record
    localStorage.removeItem('to');
  }
};

// When the request fails
const failed = (text) => {
  // eslint-disable-next-line
  Toast({
    message: text,
    position: 'bottom',
    duration: 4000,
  });
};

export default async (user) => {
  Indicator.open({
    text: 'Redirecting...',
    spinnerType: 'triple-bounce'
  });
  const rs = await api.post('login/registro/', user);
  Indicator.close();
  if (rs.data.status === 200) {
    success(rs.data.data.token);
  }
  failed(rs.data.mensaje);
};



// WEBPACK FOOTER //
// ./src/app/services/auth/signup.js